/* ============================================================================
   Sticker studio (Codex new-experience page) — phone behaviour + guards.
   • Tap art/text to select it (phones only had an unlabelled 500 ms long-press).
   • Erase / Fill close the tools drawer so the brush bar and Done are reachable.
   • Back (Android button, browser Back) closes the open drawer, sheet or dialog
     instead of leaving the studio.
   • Phones: the text toolbar sits at the bottom of the canvas; the Done bar
     moves above it.
   • Guards: Delete/Backspace never deletes art behind an open dialog; a
     double click on Add to Cart opens one proof; the low-resolution warning
     goes away when a menu is opened (it sat over menus and swallowed taps).
   Uses window._sms (state) and window._sxEnhApi.unlockObj from the section.
   ========================================================================== */
(function () {
  'use strict';
  var phone = function () { return window.innerWidth <= 768; };
  var touch = window.matchMedia && matchMedia('(pointer:coarse)').matches;
  function S() { return window._sms; }
  function visible(e) { return !!e && e.getClientRects().length > 0 && getComputedStyle(e).display !== 'none' && getComputedStyle(e).visibility !== 'hidden'; }
  function sysObj(o) { return o._isCutline || o._isCutEdge || o._isScissorIcon || o._isTemplateBg || o.visible === false; }

  // ── open overlays (top-most first) and how to close them ───────────────────
  function openOverlays() {
    var list = [];
    var add = function (el, close) { if (visible(el)) list.push({ el: el, close: close }); };
    add(document.getElementById('sxAiDlg'), function () { var b = document.getElementById('sxaCancel'); if (b) b.click(); });
    add(document.getElementById('sms-cart-popup'), function () { var b = document.getElementById('sms-cart-close'); if (b) b.click(); else document.getElementById('sms-cart-popup').remove(); });
    add(document.getElementById('sl2-proof-ol'), function () { var b = document.querySelector('#sl2-proof-ol .sl2-proof-x'); if (b) b.click(); else document.getElementById('sl2-proof-ol').remove(); });
    add(document.getElementById('sl2-aigen-ol'), function () { var b = document.getElementById('sl2agX'); if (b) b.click(); });
    // phones: the spec screen opened from the editor (Back / Escape returns to the design)
    var sp = document.getElementById('sxSpecs'); if (sp && !sp.hidden && window._sxPhoneSpecs) add(sp, function () { window._sxPhoneSpecs.close(); });
    // modals close through their x, else their Cancel (the Add Text modal has only Cancel)
    document.querySelectorAll('.sms-modal-overlay').forEach(function (m) { add(m, function () { var b = m.querySelector('.sms-modal-close') || m.querySelector('[id$="Cancel"]'); if (b) b.click(); else m.remove(); }); });
    var guide = document.getElementById('smCodexGuide');
    add(guide, function () { var b = guide.querySelector('button'); if (b) b.click(); });
    var specOpen = [].slice.call(document.querySelectorAll('.sm-spec-options')).some(visible);
    if (specOpen) list.push({ el: null, close: function () { document.dispatchEvent(new KeyboardEvent('keydown', { key: 'Escape', bubbles: true })); } });
    var panel = document.getElementById('smToolPanel');
    if (phone() && visible(panel)) add(panel, function () { var b = panel.querySelector('.sm-panel-close'); if (b) b.click(); });
    return list;
  }

  // ── Back closes the top overlay instead of leaving ─────────────────────────
  var armed = false;
  function arm() { if (!armed) { try { history.pushState({ sxStudio: 1 }, ''); armed = true; } catch (e) { } } }
  window.addEventListener('popstate', function () {
    if (!armed) return;
    armed = false;
    var o = openOverlays();
    if (o.length) { o[0].close(); arm(); }      // stay in the studio
    else history.back();                        // nothing open: leave as usual
  });
  setInterval(function () { var s = S(); if (s && s.canvas) arm(); }, 1000);

  // ── tap to select (touch screens) ──────────────────────────────────────────
  var bound = null, start = null;
  function busyMode() {
    var s = S(), er = window._sl2EraserApi, cr = window._sl2CropApi;
    return !s || s.lockMode || (er && er.getMode && er.getMode() !== 'off') || (cr && cr.isActive && cr.isActive());
  }
  // Erase/Fill or Crop running (lock mode = die-cut art editing, where pinch and finishing must still work)
  function toolMode() { var er = window._sl2EraserApi, cr = window._sl2CropApi; return !!((er && er.getMode && er.getMode() !== 'off') || (cr && cr.isActive && cr.isActive())); }
  function onStart(e) { start = e.touches.length === 1 ? { x: e.touches[0].clientX, y: e.touches[0].clientY, t: e.timeStamp } : null; }
  function onEnd(e) {
    if (!start || e.touches.length || !e.changedTouches.length) { start = null; return; }
    var t = e.changedTouches[0], moved = Math.hypot(t.clientX - start.x, t.clientY - start.y), dt = e.timeStamp - start.t;
    start = null;
    if (moved > 10 || dt > 450 || busyMode()) return;
    var s = S(), c = s.canvas, api = window._sxEnhApi || {}; if (!c || !api.unlockObj) return;
    var pt = c.getPointer(e), objs = c.getObjects(), hit = null;
    for (var i = objs.length - 1; i >= 0; i--) { var o = objs[i]; if (sysObj(o)) continue; o.setCoords(); if (o.containsPoint(pt)) { hit = o; break; } }
    if (!hit) return; // empty canvas: handled by the mouse:down hook below
    if (c.getActiveObject() === hit && hit.selectable) return;   // already selected: Fabric handles moves
    setTimeout(function () { api.unlockObj(hit); }, 0);          // after Fabric's own mouse:up
  }
  // two-finger pinch / twist on the selected art or text resizes and rotates it (it only zoomed the page, then snapped back)
  var pinch = null, swallow = false, passEnd = false; // swallow: keep the whole gesture away from the canvas until every finger lifts
  function dist(t) { return Math.hypot(t[0].clientX - t[1].clientX, t[0].clientY - t[1].clientY); }
  function ang(t) { return Math.atan2(t[1].clientY - t[0].clientY, t[1].clientX - t[0].clientX) * 180 / Math.PI; }
  function onPinchStart(e) {
    var s = S(), c = s && s.canvas, o = c && c.getActiveObject();
    if (e.touches.length !== 2 || !o || sysObj(o) || toolMode()) return;
    pinch = { c: c, o: o, d: dist(e.touches), a: ang(e.touches), sx: o.scaleX, sy: o.scaleY, r: o.angle || 0 }; start = null;
    swallow = true; passEnd = e.changedTouches.length < e.touches.length; // Fabric saw the first finger go down: let it see the last one lift
    e.preventDefault(); e.stopPropagation(); // the stage's own two-finger zoom must not run too
  }
  function onPinchMove(e) {
    if (swallow && !pinch) { e.stopPropagation(); return; } // one finger left after a pinch: no drag
    if (!pinch || e.touches.length !== 2) return;
    e.preventDefault(); e.stopPropagation();
    var k = Math.max(0.05, dist(e.touches) / (pinch.d || 1)), o = pinch.o;
    o.set({ scaleX: pinch.sx * k, scaleY: pinch.sy * k });
    if (!o.lockRotation) o.rotate(pinch.r + ang(e.touches) - pinch.a);
    o.setCoords(); pinch.c.requestRenderAll();
  }
  var lastPinch = null;
  function onPinchEnd(e) {
    if (pinch && e.touches.length < 2) { lastPinch = pinch; pinch = null; }
    if (!swallow) return;
    if (e.touches.length > 0) { e.stopPropagation(); return; } // a finger is still down: keep the gesture away from the canvas
    swallow = false;
    var p = lastPinch; lastPinch = null; if (!p) return;
    var t = p.c._currentTransform;
    if (passEnd && t && t.target === p.o) {
      // Fabric saw the first finger go down: let it see the last one lift, as a finished transform. It then fires
      // object:modified once (cut line + one undo step) and doesn't read the gesture as a tap that starts text editing.
      t.actionPerformed = true;
      return;
    }
    if (!passEnd) e.stopPropagation(); // Fabric never saw the start: a stray end would read as a click
    setTimeout(function () { p.c.fire('object:modified', { target: p.o }); }, 0);
  }
  setInterval(function () {
    var s = S(), up = s && s.canvas && s.canvas.upperCanvasEl;
    if (!touch || !up || up === bound) return;
    bound = up;
    up.addEventListener('touchstart', onStart, { passive: true });
    up.addEventListener('touchend', onEnd, { passive: true });
    // capture on the wrapper, so a pinch on the selection never reaches the stage's own pinch-zoom or Fabric's one-finger drag (both listen on the canvas)
    var wr = s.canvas.wrapperEl || up.parentNode;
    wr.addEventListener('touchstart', onPinchStart, { passive: false, capture: true });
    wr.addEventListener('touchmove', onPinchMove, { passive: false, capture: true });
    wr.addEventListener('touchend', onPinchEnd, { passive: true, capture: true });
    wr.addEventListener('touchcancel', onPinchEnd, { passive: true, capture: true });
  }, 700);

  // ── Erase / Fill close the drawer on phones (it covered the brush bar and Done) ──
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('.sms-tool-icon[data-bg="erase"],.sms-tool-icon[data-bg="fill"]');
    if (!b || !phone()) return;
    setTimeout(function () { var p = document.getElementById('smToolPanel'), x = p && p.querySelector('.sm-panel-close'); if (x && visible(p)) x.click(); }, 60);
  }, true);

  // ── phones: text toolbar at the bottom of the canvas, Done bar above it ─────
  setInterval(function () {
    var tb = document.getElementById('smsTextToolbar'), bar = document.getElementById('adjustBar');
    if (!tb || !bar) return;
    if (phone() && visible(tb)) bar.style.setProperty('bottom', (tb.offsetHeight + 16) + 'px', 'important');
    else bar.style.removeProperty('bottom');
    // 'Rotate 90°' turns a rectangle/oval sideways; in other modes it showed and did nothing
    var r90 = document.getElementById('btnRotate90'), st = S(), act = st && st.canvas && st.canvas.getActiveObject();
    if (act && act._isTemplateBg) { var dn = document.getElementById('btnDoneAdjust'); if (dn && visible(dn)) dn.click(); else { st.canvas.discardActiveObject(); st.canvas.requestRenderAll(); } }
    if (r90 && st && st.shape !== 'rectangle' && st.shape !== 'oval' && r90.style.display !== 'none') r90.style.display = 'none';
  }, 300);

  // ── guards ─────────────────────────────────────────────────────────────────
  // Delete/Backspace must not delete the selected art while a dialog is open
  window.addEventListener('keydown', function (e) {
    if (e.key !== 'Delete' && e.key !== 'Backspace') return;
    var a = document.activeElement, tag = a && a.tagName;
    if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || (a && a.isContentEditable)) return;
    if (openOverlays().some(function (o) { return o.el; })) { e.stopImmediatePropagation(); e.preventDefault(); }
  }, true);
  // one proof per Add to Cart (a double click stacked two proofs)
  var atcBusy = 0;
  document.addEventListener('click', function (e) {
    if (!(e.target && e.target.closest && e.target.closest('#btnATCBottom'))) return;
    if (document.getElementById('sl2-proof-ol') || atcBusy) { e.stopImmediatePropagation(); e.preventDefault(); return; }
    atcBusy = 1; setTimeout(function () { atcBusy = 0; }, 1500);
  }, true);
  // opening a menu dismisses the low-resolution warning (it sat above menus and swallowed taps)
  document.addEventListener('pointerdown', function (e) {
    var t = document.getElementById('smsDpiToast');
    if (t && e.target && e.target.closest && e.target.closest('.sm-spec-toggle,.sm-rail-button,#sxLayers,.sm-tool-panel,.sx-enh-float,#adjustBar')) t.remove();
  }, true);

  // ── Erase "Done" and Crop rebuild the cut line (shared utils call _sl2DC, which this page never defined) ──
  if (!window._sl2DC) window._sl2DC = function () {
    var s = S(), a = window._sxEnhApi; if (!s || !s.canvas || !a) return;
    if (s.shape === 'die-cut') a.drawCutline(); else if (a.redrawAfterEdit) a.redrawAfterEdit();
  };
  // ending crop re-locks the art like a fresh page (it stayed selectable: one click opened the Adjust bar)
  function endCrop() { if (window._sl2ExitCrop) window._sl2ExitCrop(); var s = S(); if (s && !s.adjusting && window._sl2LockAll) window._sl2LockAll(); }
  // Crop: Keep Inside / Delete finish the crop (it stayed on and swallowed the next clicks)
  document.addEventListener('click', function (e) {
    if (!(e.target && e.target.closest && e.target.closest('._keep,._del'))) return;
    var cr = window._sl2CropApi; if (!(cr && cr.isActive && cr.isActive())) return;
    setTimeout(endCrop, 0);
  }, true);

  // ── dialogs: × always closes, Escape closes the top one, focus moves in and comes back ──
  // (the QR dialog's × had no handler; on landscape phones its Cancel is below the fold)
  document.addEventListener('click', function (e) {
    var x = e.target && e.target.closest && e.target.closest('.sms-modal-overlay .sms-modal-close'); if (!x) return;
    var m = x.closest('.sms-modal-overlay');
    setTimeout(function () {
      if (!visible(m)) return;
      var c = m.querySelector('[id$="Cancel"]'); if (c) c.click(); else m.remove();
    }, 0);
  });
  var escBusy = false;
  window.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || escBusy) return;
    var cr = window._sl2CropApi;
    if (cr && cr.isActive && cr.isActive()) { e.preventDefault(); endCrop(); return; }
    var o = openOverlays().filter(function (x) { return x.el && x.el.id !== 'smToolPanel'; })[0];
    if (!o) return; // spec popovers and the phone drawer keep their own Escape handling
    var a = document.activeElement;
    if (a && /^(INPUT|TEXTAREA)$/.test(a.tagName) && !o.el.contains(a)) return; // e.g. typing on the canvas
    e.preventDefault(); e.stopImmediatePropagation();
    escBusy = true; try { o.close(); } finally { escBusy = false; }
  }, true);
  var opened = []; // [{el, back}]
  // the control that opened a dialog: dialogs focus their own fields before we see them, so remember the last control used
  var opener = null;
  ['pointerdown', 'keydown'].forEach(function (t) { document.addEventListener(t, function (e) { var b = e.target && e.target.closest && e.target.closest('button,a[href],[role=button],input,select'); if (b && !openOverlays().some(function (o) { return o.el && o.el.id !== 'smToolPanel' && o.el.contains(b); })) opener = b; }, true); });
  function focusables(el) { return [].slice.call(el.querySelectorAll('button,[href],input:not([type=hidden]),select,textarea,[tabindex]:not([tabindex="-1"])')).filter(function (n) { return !n.disabled && visible(n); }); }
  setInterval(function () {
    var now = openOverlays().map(function (x) { return x.el; }).filter(function (el) { return el && el.id !== 'smToolPanel' && el.id !== 'smCodexGuide'; });
    opened = opened.filter(function (r) {
      if (now.indexOf(r.el) >= 0) return true;
      if (r.back && document.contains(r.back) && (!touch || /^(BUTTON|A)$/.test(r.back.tagName)) && (!document.activeElement || document.activeElement === document.body || r.el.contains(document.activeElement))) { try { r.back.focus({ preventScroll: true }); } catch (x) { } }
      return false;
    });
    now.forEach(function (el) {
      if (opened.some(function (r) { return r.el === el; })) return;
      var box = el.matches('.sms-modal-overlay') ? (el.querySelector('.sms-modal-box') || el) : el;
      if (!box.getAttribute('role')) { box.setAttribute('role', 'dialog'); box.setAttribute('aria-modal', 'true'); }
      var back = document.activeElement && document.activeElement !== document.body && !el.contains(document.activeElement) ? document.activeElement : opener;
      if (el.id === 'sms-cart-popup' && (!back || back.id !== 'sxCartBtn')) back = document.getElementById('btnATCBottom');
      opened.push({ el: el, back: back });
      if (!el.contains(document.activeElement)) { var f = focusables(el), first = f.filter(function (n) { return n.tagName === 'BUTTON'; })[0] || f[0]; if (first && (!touch || first.tagName === 'BUTTON')) try { first.focus({ preventScroll: true }); } catch (x) { } }
    });
  }, 250);
  // Tab stays inside the open dialog
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || !opened.length) return;
    var el = opened[opened.length - 1].el, f = focusables(el); if (!f.length) return;
    var i = f.indexOf(document.activeElement);
    if (i < 0) { e.preventDefault(); f[0].focus(); }
    else if (!e.shiftKey && i === f.length - 1) { e.preventDefault(); f[0].focus(); }
    else if (e.shiftKey && i === 0) { e.preventDefault(); f[f.length - 1].focus(); }
  }, true);

  // ── one printed size label (W × H) for the card, the proof and the cart: die-cut from the cut line, shapes from the shape ──
  window._sxSizeWH = function (bare) {
    var s = S(), n = Number(s && s.sizeInches), core = window.StudioCutlineCore, a = window._sxEnhApi || {}, w = 0, h = 0;
    if (!s || !(n > 0)) return '';
    if (s.shape === 'die-cut') { var b = s.cutContourPaths && core && core.bounds(s.cutContourPaths); if (b) { w = b.width; h = b.height; } }
    else { // shapes: the outer cut line (shape + border), which is what prints
      var e = s.canvas && s.canvas.getObjects().filter(function (o) { return o._isCutEdge; })[0];
      if (e) { w = e.width * (e.scaleX || 1); h = e.height * (e.scaleY || 1); }
      else if (a.getShapeDims) { var d = a.getShapeDims(); if (d) { w = d[0]; h = d[1]; } }
    }
    if (!(w > 0 && h > 0)) return '';
    var k = s.shape==='die-cut'&&s.artworkUnitInches>0?s.artworkUnitInches:n / Math.max(w, h), f = function (v) { return String(Math.round(v * k * 100) / 100); };
    return f(w) + ' × ' + f(h) + (bare ? '' : '"');
  };

  // ── canvas fixes, bound to each new canvas ──
  // • selected objects keep their layer (Fabric drew them on top: a template's white background covered the whole design)
  // • in shape modes, images added later (QR, AI image, extra uploads) are clipped to the shape like clipart and text
  // • a gradient on text stretches with the text when it's edited (it stayed at the old width, the rest flat colour)
  var boundC = null, pendingText = 0;
  function fixGrad(o) {
    var f = o && o.fill;
    if (!f || f.type !== 'linear' || !f.coords || !/text/.test(o.type || '')) return;
    if (f.coords.x1 === 0 && f.coords.y1 === f.coords.y2 && Math.abs(f.coords.x2 - o.width) > 0.5) { f.coords.x2 = o.width; o.dirty = true; }
  }
  setInterval(function () {
    if (window.fabric && fabric.Canvas && !fabric.Canvas.prototype.preserveObjectStacking) fabric.Canvas.prototype.preserveObjectStacking = true;
    var s = S(), c = s && s.canvas; if (!c || c === boundC) return;
    boundC = c; c.preserveObjectStacking = true;
    c.on('object:added', function (ev) {
      var o = ev.target, st = S(), a = window._sxEnhApi || {};
      if (o && /text/.test(o.type || '') && Date.now() - pendingText < 4000) { pendingText = 0; setTimeout(function () { if (c.getActiveObject() !== o && c.getObjects().indexOf(o) >= 0 && a.unlockObj) a.unlockObj(o); }, 700); }
      if (!o || !st || st.shape === 'die-cut' || o.clipPath || sysObj(o) || o._isTemplateBg || !a.shapeClip) return;
      try { o.clipPath = a.shapeClip(); o.dirty = true; } catch (e) { }
    });
    c.on('text:changed', function (ev) {
      var o = ev.target; fixGrad(o);
      // keep text being typed inside the canvas (big auto-fitted text ran thousands of px off-screen with the caret)
      if (!o || !o.isEditing) return;
      var ar = document.querySelector('.sms-canvas-area'), rr = c.upperCanvasEl.getBoundingClientRect(), ab = ar && ar.getBoundingClientRect(), kk = rr.height / c.getHeight() || 1;
      var vw = ab ? Math.min(c.getWidth(), ab.width / kk) : c.getWidth(), vh = ab ? Math.min(c.getHeight(), ab.height / kk) : c.getHeight();
      var lim = vw * 0.9, w = o.getScaledWidth(), hh = o.getScaledHeight(), lh = vh * 0.8;
      var k = Math.min(w > lim ? lim / w : 1, hh > lh ? lh / hh : 1);
      if (k < 1) { o.set({ scaleX: o.scaleX * k, scaleY: o.scaleY * k }); o.setCoords(); c.requestRenderAll(); }
    });
    c.on('text:editing:exited', function (ev) {
      fixGrad(ev.target); c.requestRenderAll();
      // Escape ended editing with nothing selected but left the Done bar up: finish the edit
      setTimeout(function () { var st = S(), d = document.getElementById('btnDoneAdjust'); if (st && st.adjusting && !c.getActiveObject() && d && visible(d)) d.click(); }, 80);
    });
    c.on('object:modified', function (ev) { fixGrad(ev.target); });
    // a press on empty canvas finishes art/text editing (the Done bar stayed up)
    c.on('mouse:down', function (ev) {
      if (ev.target || pinch || toolMode()) return;
      var st = S(), d = document.getElementById('btnDoneAdjust'), a = c.getActiveObject();
      if (st && st.adjusting && d && visible(d) && !(a && a.isEditing)) setTimeout(function () { if (S().adjusting && visible(d)) d.click(); }, 0);
    });
    // a template's hidden white background is not something to edit: leave edit mode instead of selecting it
    c.on('selection:created', function (ev) {
      var o = ev.selected && ev.selected[0]; if (!o || !o._isTemplateBg) return;
      setTimeout(function () { if (c.getActiveObject() !== o) return; var d = document.getElementById('btnDoneAdjust'); if (d && visible(d)) d.click(); else { c.discardActiveObject(); c.requestRenderAll(); } }, 50);
    });
  }, 500);

  // text added before its web font loaded was measured with the fallback font (the cut and size came out wrong
  // until something else rebuilt it, e.g. stock templates): re-measure when fonts arrive
  if (document.fonts && document.fonts.addEventListener) document.fonts.addEventListener('loadingdone', function () {
    var s = S(), c = s && s.canvas, a = window._sxEnhApi, changed = false; if (!c || !window.fabric) return;
    c.getObjects().forEach(function (o) {
      if (!/text/.test(o.type || '') || o.isEditing) return;
      var w = o.width, h = o.height;
      try { fabric.util.clearFabricFontCache(o.fontFamily); o.initDimensions(); o.setCoords(); o.dirty = true; } catch (e) { }
      if (Math.abs(o.width - w) > 0.5 || Math.abs(o.height - h) > 0.5) changed = true;
    });
    if (!changed) return;
    c.requestRenderAll();
    if (a && !s.adjusting) { if (s.shape === 'die-cut') a.drawCutline(); else if (a.redrawAfterEdit) a.redrawAfterEdit(); }
  });

  // ── small notes (top of the canvas) ──
  function note(msg) {
    var t = document.getElementById('sxNote'); if (t) t.remove();
    t = document.createElement('div'); t.id = 'sxNote'; t.setAttribute('role', 'status'); t.setAttribute('data-sx-keep', '');
    t.appendChild(document.createElement('div')).textContent = msg;
    var ar = document.querySelector('.sms-canvas-area'), rc = ar && ar.getBoundingClientRect();
    if (rc && rc.width > 0 && rc.top < innerHeight) t.style.top = Math.max(8, rc.top + 56) + 'px';
    document.body.appendChild(t);
    setTimeout(function () { if (t.parentNode) t.remove(); }, 3800);
  }
  (function () { var st = document.createElement('style'); st.textContent = '#sxNote{position:fixed;left:0;right:0;top:90px;z-index:10001;display:flex;justify-content:center;pointer-events:none}#sxNote>div{pointer-events:auto;max-width:min(420px,calc(100vw - 32px));padding:10px 14px;border-radius:10px;background:#111827;color:#fff;font:600 13px/1.4 Inter,Arial,sans-serif;box-shadow:0 6px 20px rgba(0,0,0,.18);text-align:center}.sms-custom-input.sx-bad{border-color:#d93025!important;background:#fff5f5!important}'; (document.head || document.documentElement).appendChild(st); })();

  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('.sms-tool-icon[data-bg]'), s = S();
    if (!b) return;
    // Background tools before any artwork did nothing, silently
    if (!s || !s.canvas) { e.preventDefault(); e.stopImmediatePropagation(); note('Upload your artwork first, then pick a background option.'); return; }
    // paid AI removal: a second click while it runs (or once it's applied) re-sent the paid request
    var m = b.dataset.bg;
    if (m === 'none' && (s.bgMode || 'none') === 'none' && !s.processedImg && !s.bgPending) { var g = window._sxEnhApi && window._sxEnhApi.getMainImage, mi = g && g(); if (mi && mi.getElement() === s.originalImg) { e.preventDefault(); e.stopImmediatePropagation(); return; } }
    if ((m === 'pro' || m === 'ai') && (s.bgPending || s.bgMode === m)) { e.preventDefault(); e.stopImmediatePropagation(); if (s.bgPending) note('Background removal is already running.'); }
  }, true);
  // phones: Crop had no instruction
  document.addEventListener('click', function (e) {
    if (!(e.target && e.target.closest && e.target.closest('#btnCrop'))) return;
    setTimeout(function () { var cr = window._sl2CropApi; if (cr && cr.isActive && cr.isActive()) note('Drag over the area to keep or delete, then choose Keep Inside or Delete.'); }, 120);
  });
  // adding an image from a drawer closes the drawer (it covered the new image on phones)
  document.addEventListener('change', function (e) {
    if (!phone() || !(e.target && /^(fileInput|addImageInput)$/.test(e.target.id))) return;
    var p = document.getElementById('smToolPanel'), x = p && p.querySelector('.sm-panel-close'); if (x && visible(p)) x.click();
  }, true);
  // new text is selected after Add Text (the toolbar and Delete were unavailable until it was tapped); see object:added below
  ['pointerdown', 'touchstart', 'click'].forEach(function (t) { document.addEventListener(t, function (e) { if (e.target && e.target.closest && e.target.closest('#smsTextAdd')) pendingText = Date.now(); }, true); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Enter' && e.target && e.target.id === 'smsTextInput') pendingText = Date.now(); }, true);
  // locked quantity buttons leave the keyboard order (Enter on one silently closed the popover)
  setInterval(function () {
    document.querySelectorAll('.sl2-pill[data-qty],.sms-qty-pre[data-qty]').forEach(function (b) {
      var lk = b.classList.contains('sms-locked');
      if (lk && b.getAttribute('aria-disabled') !== 'true') { b.setAttribute('aria-disabled', 'true'); b.tabIndex = -1; }
      else if (!lk && b.getAttribute('aria-disabled') === 'true') { b.removeAttribute('aria-disabled'); b.removeAttribute('tabindex'); }
    });
  }, 600);
  // Bold / Italic / Outline keep the text selected (the cut rebuild after each one dropped the selection and closed the toolbar)
  document.addEventListener('click', function (e) {
    if (!(e.target && e.target.closest && e.target.closest('#smsTbBold,#smsTbItalic,#smsTbStroke'))) return;
    var s = S(), c = s && s.canvas, o = c && c.getActiveObject(); if (!o) return;
    setTimeout(function () { var a = window._sxEnhApi; if (c.getActiveObject() !== o && c.getObjects().indexOf(o) >= 0 && a && a.unlockObj) a.unlockObj(o); }, 60);
  }, true);
  // spec popovers close when Tab leaves them or Add to Cart / the cart button is used (they stayed open)
  function closeSpecs() {
    // close directly: the page's Escape handler would also pull focus back to the toggle
    document.querySelectorAll('.sm-spec-options').forEach(function (p) { if (!p.hidden) p.hidden = true; });
    document.querySelectorAll('.sm-spec-toggle[aria-expanded="true"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
  }
  document.addEventListener('focusin', function (e) { if (e.target && e.target.closest && !e.target.closest('.sm-spec-options,.sm-spec-toggle') && !openOverlays().some(function (o) { return o.el; })) closeSpecs(); }, true);
  document.addEventListener('pointerdown', function (e) { if (e.target && e.target.closest && e.target.closest('#btnATCBottom,#sxCartBtn')) closeSpecs(); }, true);
  // font size box: a partial number (the 4 of 48) was applied, then the cut rebuild dropped the selection and the text stayed at 4 pt
  var sizeObj = null;
  document.addEventListener('focusin', function (e) { if (e.target && e.target.id === 'smsTbSize') { var s = S(); sizeObj = s && s.canvas && s.canvas.getActiveObject(); } }, true);
  document.addEventListener('input', function (e) {
    if (!e.target || e.target.id !== 'smsTbSize') return;
    var s = S(), c = s && s.canvas, a = window._sxEnhApi, v = parseInt(e.target.value, 10);
    if (c && sizeObj && c.getActiveObject() !== sizeObj && c.getObjects().indexOf(sizeObj) >= 0 && a && a.unlockObj) a.unlockObj(sizeObj);
    if (!(v >= 8 && v <= 200)) { e.stopImmediatePropagation(); return; } // wait for a usable size
    var box = e.target, o = sizeObj;
    setTimeout(function () { var cc = S() && S().canvas; if (!cc || !o || cc.getActiveObject() === o || cc.getObjects().indexOf(o) < 0 || !a || !a.unlockObj) return; a.unlockObj(o); setTimeout(function () { if (visible(box)) { box.focus({ preventScroll: true }); } }, 60); }, 900);
  }, true);
  document.addEventListener('change', function (e) {
    if (!e.target || e.target.id !== 'smsTbSize') return;
    var v = parseInt(e.target.value, 10), w = Math.min(200, Math.max(8, v || 36));
    if (w !== v) { e.target.value = String(w); e.target.dispatchEvent(new Event('input', { bubbles: true })); }
  }, true);
  setInterval(function () {
    document.querySelectorAll('.sms-modal-item:not([tabindex]),.sms-template-card:not([tabindex])').forEach(function (d) { d.tabIndex = 0; d.setAttribute('role', 'button'); if (!d.getAttribute('aria-label')) d.setAttribute('aria-label', (d.getAttribute('title') || d.textContent || 'Choose').trim().slice(0, 40)); });
  }, 500);
  document.addEventListener('keydown', function (e) { if ((e.key === 'Enter' || e.key === ' ') && e.target && e.target.matches && e.target.matches('.sms-modal-item,.sms-template-card')) { e.preventDefault(); e.target.click(); } });
  // a failed cart add showed a clipped 'Error: …' on the green button for 3.5 s: turn it red and show the whole message
  (function () {
    var b = document.getElementById('btnATCBottom'); if (!b || !window.MutationObserver) return;
    new MutationObserver(function () {
      var err = /^\s*Error:/.test(b.textContent || '');
      if (err && !b.classList.contains('sx-atc-err')) note('Couldn’t add to cart: ' + b.textContent.replace(/^\s*Error:\s*/, '') + ' Please try again.');
      b.classList.toggle('sx-atc-err', err);
    }).observe(b, { childList: true, characterData: true, subtree: true });
  })();
  // invalid custom size boxes turn red (the section's red border was overridden by the theme's !important)
  document.addEventListener('input', function (e) {
    var t = e.target; if (!t || (t.id !== 'smsCustomW' && t.id !== 'smsCustomH')) return;
    [document.getElementById('smsCustomW'), document.getElementById('smsCustomH')].forEach(function (i) { if (!i) return; var v = parseFloat(i.value); i.classList.toggle('sx-bad', !(v >= 0.5 && v <= 20)); });
  });

  // ── die-cut custom size: the art keeps its proportions, so the other side follows the one typed ──
  // (4 × 2 used to become 4 × 3.81 on the card, proof and cart while the box still said 2)
  var syncing = false;
  function artAspect() {
    var s = S(), core = window.StudioCutlineCore; if (!s || s.shape !== 'die-cut' || !s.cutContourPaths || !core) return 0;
    var b = core.bounds(s.cutContourPaths); return b && b.width > 0 && b.height > 0 ? b.height / b.width : 0;
  }
  function follow(id) {
    var t = document.getElementById(id), k = artAspect(), v = t && parseFloat(t.value); if (!k || !(v > 0)) return;
    var o = document.getElementById(id === 'smsCustomW' ? 'smsCustomH' : 'smsCustomW'); if (!o) return;
    var r = id === 'smsCustomW' ? k : 1 / k, ov = v * r;
    // keep both sides in 0.5-20 in: if the following side would leave the range, pull the typed side back to fit
    if (ov > 20) { ov = 20; t.value = String(Math.round(20 / r * 100) / 100); } else if (ov < 0.5) { ov = 0.5; t.value = String(Math.round(0.5 / r * 100) / 100); }
    var nv = String(Math.round(ov * 100) / 100); if (o.value === nv) return;
    syncing = true; o.value = nv; o.dispatchEvent(new Event('input', { bubbles: true })); syncing = false;
  }
  var lastTyped = 0;
  document.addEventListener('input', function (e) { var id = e.target && e.target.id; if (!syncing && (id === 'smsCustomW' || id === 'smsCustomH')) { lastTyped = Date.now(); follow(id); } }, true);
  document.addEventListener('change', function (e) { if (e.target && e.target.id === 'sz-custom') setTimeout(function () { follow('smsCustomW'); }, 0); }, true);
  setInterval(function () { // hint under the boxes while die-cut
    var p = document.getElementById('smsCustomSize'); if (!p) return;
    var h = document.getElementById('sxCustomHint'), s = S(), on = !!(s && s.shape === 'die-cut');
    if (!h) { h = document.createElement('div'); h.id = 'sxCustomHint'; h.textContent = 'Die-cut keeps your art’s proportions: the other side follows.'; p.appendChild(h); }
    h.hidden = !on;
    // the art changed after the size was typed (text added, erased...): show the real W x H in the boxes again
    var W = document.getElementById('smsCustomW'), Hb = document.getElementById('smsCustomH'), ae = document.activeElement, core = window.StudioCutlineCore;
    if (!on || s.artworkUnitInches>0 || s.size !== 'custom' || !s.cutContourPaths || !core || !W || !Hb || ae === W || ae === Hb || Date.now() - lastTyped < 1500) return;
    var vw = parseFloat(W.value), vh = parseFloat(Hb.value); if (!(vw >= 0.5 && vw <= 20 && vh >= 0.5 && vh <= 20)) return;
    var b = core.bounds(s.cutContourPaths), n = Number(s.sizeInches); if (!b || !(b.width > 0) || !(n > 0)) return;
    var kk = n / Math.max(b.width, b.height), w = Math.round(b.width * kk * 100) / 100, hh = Math.round(b.height * kk * 100) / 100;
    if (Math.max(w, hh) !== Math.round(n * 100) / 100) return;
    if (vw !== w) W.value = String(w); if (vh !== hh) Hb.value = String(hh);
  }, 800);
})();
